module.exports = __webpack_public_path__ + "static/media/4 6 tattoo forearm wolf cub forest scenic atmospheric.1280x1920.32d37cf0.webp";